import { render, staticRenderFns } from "./CmsRichTileCard.vue?vue&type=template&id=3d83c3f6&scoped=true"
import script from "./CmsRichTileCard.vue?vue&type=script&lang=ts"
export * from "./CmsRichTileCard.vue?vue&type=script&lang=ts"
import style0 from "./CmsRichTileCard.vue?vue&type=style&index=0&id=3d83c3f6&prod&lang=scss&scoped=true"
import style1 from "./CmsRichTileCard.vue?vue&type=style&index=1&id=3d83c3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83c3f6",
  null
  
)

/* custom blocks */
import block0 from "./CmsRichTileCard.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports